<template>
  <div class="hcl-form-element-toggle custom-control custom-switch">
    <input type="checkbox" class="hcl-form-element-toggle custom-control-input" :id="fieldName" :name="fieldName"
      :disabled="isReadOnly(props.definitionField.field)" v-model="checked" :widget="props.definitionField.field.widget?.widget"
      v-bind="generateDataAttributes">
    <label class="custom-control-label" :for="fieldName"></label>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'

import { useElement } from '@/components/FormElement/element'

interface Props {
  definitionField: any
  dataField: any
  dataLookup: any,
  dropdownmode?: any
}

const props = withDefaults(defineProps<Props>(), {
  definitionField: undefined,
  dataField: undefined,
  dataLookup: undefined,
  dropdownmode: undefined
})

const { isReadOnly, fieldName, generateDataAttributes } = useElement(props)

const checked = ref(props.dataField.value === 'on')

watch(
  checked,
  (n) => {
    props.dataField.value = n ? 'on' : 'off'
  }
)
</script>

<style lang="scss" scoped>
.hcl-form-element-toggle {
  width: 100%;
}
</style>
